import { faqs } from "../../utilities/faqs"

const FAQs = () => {
	return (
		<div id='faqs' className='app-x relative pb-14 bg-gradient-to-b from-slate-50 via-white to-slate-50 py-14'>
			<h3 className="text-center py-2 w-fit mx-auto px-6 relative text-primary text-2xl font-serif font-bold">
				Frequently Asked Questions
				<svg className="w-6 h-6 absolute right-0 top-0" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path className="stroke-primary" d="M5.38769 8.32827C5.38769 8.32827 8.65629 3.6393 13 1.56276" strokeWidth="1.6" strokeLinecap="round" />
					<path className="stroke-primary" d="M6.36502 12.6173C6.36502 12.6173 8.91689 11.2253 11.3245 11.0555" strokeWidth="1.6" strokeLinecap="round" />
					<path className="stroke-primary" d="M1.00001 5.87406C1.00001 5.87406 2.85086 3.91533 3.71987 1.72824" strokeWidth="1.6" strokeLinecap="round" />
				</svg>
			</h3>
			<hr className="w-1/3 mx-auto mt-5 mb-10 " />

			<div className="grid md:grid-cols-2 gap-10">
				{faqs.map(({ question, answer }, i) => (
					<div key={i} className="py-5 flex space-x-3 border-b">
						<div className="flex justify-center items-center p-2 h-8 w-8 border rounded-md text-primary ">?</div>
						<div>
							<h3 className="mb-5 font-bold text-lg text-slate-700">{question}</h3>
							<div className="text-sm">{answer}</div>
						</div>
					</div>
				))}
			</div>
		</div>
	)
}

export default FAQs